import React from 'react';

const Education = () => {
  const education = [
    {
      degree: "Applied Mathematics",
      institution: "University of Tunis El Manar",
      period: "September 2021 - Present",
      description: "Specialized in mathematical modeling, statistical analysis, and computational mathematics with applications in data science and machine learning.",
      icon: "fa-graduation-cap",
      color: "from-blue-500 to-blue-600",
      status: "Current"
    },
    {
      degree: "Experimental Sciences",
      institution: "Ibn Abi Dief High School",
      period: "September 2017 - June 2021",
      description: "Strong foundation in mathematics, physics, and natural sciences, preparing for advanced studies in applied mathematics.",
      icon: "fa-school",
      color: "from-green-500 to-green-600",
      status: "Completed"
    }
  ];

  return (
    <section id="education" className="section-padding bg-white/70 backdrop-blur-md shadow-lg">
      <div className="container-max">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Education</h2>
          <div className="w-20 h-1 bg-primary-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Academic background and educational achievements that shaped my expertise
          </p>
        </div>

        <div className="max-w-4xl mx-auto px-2">
          <div className="relative">
            <div className="absolute left-2 sm:left-8 top-0 bottom-0 w-0.5 bg-primary-200"></div>
            {education.map((edu, index) => (
              <div key={index} className="relative pl-6 sm:pl-20 pb-8 sm:pb-12 last:pb-0 min-w-0">
                <div className={`absolute left-0 sm:left-6 w-4 h-4 bg-gradient-to-r ${edu.color} rounded-full border-4 border-white shadow-lg`}></div>
                <div className="bg-white p-4 sm:p-8 rounded-lg shadow-lg card-hover border border-gray-100 overflow-x-auto">
                  <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between mb-6 flex-wrap min-w-0">
                    <div className="flex items-start space-x-2 sm:space-x-4 min-w-0">
                      <div className={`w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r ${edu.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                        <i className={`fas ${edu.icon} text-xl sm:text-2xl text-white`}></i>
                      </div>
                      <div className="min-w-0">
                        <h3 className="text-2xl font-bold text-gray-900 mb-2">{edu.degree}</h3>
                        <h4 className="text-xl text-primary-600 font-semibold mb-2">{edu.institution}</h4>
                        <div className="flex items-center space-x-4">
                          <span className="text-gray-600 font-medium">
                            <i className="fas fa-calendar-alt mr-2"></i>
                            {edu.period}
                          </span>
                          <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                            edu.status === 'Current' 
                              ? 'bg-green-100 text-green-800' 
                              : 'bg-blue-100 text-blue-800'
                          }`}>
                            {edu.status}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <p className="text-gray-700 leading-relaxed">
                    {edu.description}
                  </p>
                  
                  {edu.degree === "Applied Mathematics" && (
                    <div className="mt-6">
                      <h5 className="font-semibold text-gray-900 mb-3">Key Areas of Study:</h5>
                      <div className="flex flex-wrap gap-2">
                        {[
                          "Mathematical Modeling",
                          "Statistical Analysis",
                          "Computational Mathematics",
                          "Numerical Methods",
                          "Probability Theory",
                          "Linear Algebra"
                        ].map((area, areaIndex) => (
                          <span 
                            key={areaIndex}
                            className="bg-primary-100 text-primary-800 px-3 py-1 rounded-full text-sm font-medium"
                          >
                            {area}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
